const { types, referenceTypes, uiTypes } = require("../utils/types");
const { validatorTypes } = require("../utils/validatorTypes");

const textValuesUI = {
  // added for ui
  type: uiTypes.TEXT, //UI Types
  validation: [], //UI Validation
  list: false,
  read: true,
  create: true,
  edit: true,
};
const obj = {
  tableName: "properties",
  read: true,
  create: true,
  edit: true,
  delete: true,
  comments: false, //for enabiling comments on view and edit
  references: [
    {
      tableName: "property_types",
      foreignKey: "property_type_id",
      primaryKey: "id",
      type: referenceTypes.ONE,
      displayKey: "name",
    },

    {
      tableName: "country_cites",
      foreignKey: "country_city_id",
      primaryKey: "id",
      type: referenceTypes.ONE,
      displayKey: "name",
    },
    {
      tableName: "city",
      foreignKey: "city_id",
      primaryKey: "id",
      type: referenceTypes.ONE,
      displayKey: "name",
    },
    {
      tableName: "locality",
      foreignKey: "locality_id",
      primaryKey: "id",
      type: referenceTypes.ONE,
      displayKey: "main_location",
    },
  ],
  columns: [
    {
      name: "id",
      type: types.UUID,
      allowNull: false,
      defaultValue: types.UUIDV4,
      primaryKey: true,
      validation: [validatorTypes.uuid, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.TEXT, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "title",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.required],
      ui: {
        ...textValuesUI,
        validation: [validatorTypes.string, validatorTypes.required],
        list: true,
      },
    },
    {
      name: "slug",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.required],
      ui: {
        ...textValuesUI,
        validation: [validatorTypes.string, validatorTypes.required],
        list: true,
      },
    },
    {
      name: "summary",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        type: uiTypes.EDITOR,
        validation: [],
        list: false,
        read: true,
        create: true,
        edit: true,
        validation: [validatorTypes.string, validatorTypes.required],
      },
    },
    {
      name: "card_special_offer_text",
      type: types.BOOLEAN,
      isArray: false,
      defaultValue: true,
      validation: [validatorTypes.bool, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.SWITCH, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "tagline",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },

    {
      name: "price",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },
    {
      name: "property_type_id",
      type: types.UUID,
      validation: [validatorTypes.uuid, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DROPDOWN, //UI Types
        validation: [validatorTypes.string, validatorTypes.required],
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "country_city_id",
      type: types.UUID,
      validation: [validatorTypes.uuid, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.COUNTRY_CITY_LOCALITY, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "city_id",
      type: types.UUID,
      validation: [validatorTypes.uuid, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DROPDOWN, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: true,
        edit: true,
        display: false,
      },
    },
    {
      name: "locality_id",
      type: types.UUID,
      validation: [validatorTypes.uuid, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DROPDOWN, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: true,
        edit: true,
        display: false,
      },
    },
    {
      name: "marquee_text",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },

    // {
    //   name: "status",
    //   type: types.BOOLEAN,
    //   isArray: false,
    //   defaultValue: true,
    //   validation: [validatorTypes.bool, validatorTypes.optional],
    //   ui: {
    //     // added for ui
    //     type: uiTypes.SWITCH, //UI Types
    //     validation: [], //UI Validation
    //     list: true,
    //     read: true,
    //     create: true,
    //     edit: true,
    //   },
    // },
    {
      name: "display",
      type: types.BOOLEAN,
      isArray: false,
      defaultValue: true,
      validation: [validatorTypes.bool, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.SWITCH, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "email_sent",
      type: types.BOOLEAN,
      isArray: false,
      defaultValue: false,
      validation: [validatorTypes.bool, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.SWITCH, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "property_status",
      type: types.ENUM,
      allowNull: true,
      enumValues: ["resale", "under-construction", "new-construction"],
      ui: {
        type: uiTypes.DROPDOWN,
        validation: [validatorTypes.string, validatorTypes.optional],
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "image_title",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },
    {
      name: "image_subtitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },
    {
      name: "image_description",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },
    {
      name: "images",
      type: types.JSON,
      isArray: true,
      allowNull: true,
      validation: [validatorTypes.array, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.MULTI_IMAGE_VIDEO, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "assets",
      type: types.JSON,
      isArray: true,
      allowNull: true,
      validation: [validatorTypes.array, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.MULTI_IMAGE_VIDEO, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "overview",
      type: types.JSON,
      isArray: true,
      allowNull: true,
      validation: [validatorTypes.array, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DYNAMICJSON, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
        dynamicArrayfeilds: [
          {
            name: "title",
            type: "text", //image , text, textarea, key_value
          },
          {
            name: "subtitle",
            type: "text", //image , text, textarea, key_value
          },
          {
            name: "priority",
            type: "text", //image , text, textarea, key_value
          },
        ], // incas
      },
    },
    {
      name: "details_image",
      type: types.JSON,
      isArray: false,
      allowNull: true,
      validation: [validatorTypes.json, validatorTypes.required],
      ui: {
        // added for ui
        type: uiTypes.DOCUMENT_ALT, //UI Types
        validation: [validatorTypes.required], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "overview_image",
      type: types.JSON,
      isArray: false,
      allowNull: true,
      validation: [validatorTypes.json, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DOCUMENT_ALT, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
      },
    },

    {
      name: "card_icons",
      type: types.JSON,
      isArray: true,
      allowNull: true,
      validation: [validatorTypes.array, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DYNAMICJSON, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
        dynamicArrayfeilds: [
          {
            name: "title",
            type: "text", //image , text, textarea, key_value
          },
          {
            name: "subtitle",
            type: "text", //image , text, textarea, key_value
          },
          {
            name: "priority",
            type: "text", //image , text, textarea, key_value
          },
          {
            name: "infobox",
            type: "text", //image , text, textarea, key_value
          },
          {
            name: "icon_image",
            type: "image", //image , text, textarea, key_value
          },
        ], // incas
      },
    },
    {
      name: "faq",
      type: types.JSON,
      isArray: true,
      allowNull: true,
      validation: [validatorTypes.array, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DYNAMICJSON, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
        dynamicArrayfeilds: [
          {
            name: "question",
            type: "text", //image , text, textarea, key_value
          },
          {
            name: "answer",
            type: "textarea", //image , text, textarea, key_value
          },
          {
            name: "priority",
            type: "text", //image , text, textarea, key_value
          },
        ], // incas
      },
    },
    {
      name: "signature_title",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },
    {
      name: "signature_subtitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },
    {
      name: "signature_features",
      type: types.JSON,
      isArray: true,
      allowNull: true,
      validation: [validatorTypes.array, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DYNAMICJSON, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
        dynamicArrayfeilds: [
          {
            name: "title",
            type: "text", //image , text, textarea, key_value
          },
          {
            name: "priority",
            type: "text", //image , text, textarea, key_value
          },
          {
            name: "vector_art",
            type: "image", //image , text, textarea, key_value
          },
          {
            name: "description",
            type: "textarea", //image , text, textarea, key_value
          },
        ], // incas
      },
    },
    {
      name: "take_tour_image",
      type: types.JSON,
      isArray: false,
      allowNull: true,
      validation: [validatorTypes.json, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DOCUMENT_ALT, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "youtube_link",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },
    {
      name: "button_text",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },

    {
      name: "document_title",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },

    {
      name: "document_subtitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
        type: uiTypes.TEXT_AREA,
      },
    },

    {
      name: "lat",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },

    {
      name: "long",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },
    {
      name: "address",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
        type: uiTypes.TEXT_AREA,
      },
    },

    {
      name: "configuation",
      type: types.ENUM,
      allowNull: false,
      defaultValue: "disabled",
      enumValues: ["1bhk", "2bhk", "3bhk", "4bhk", "studio"],
      ui: {
        type: uiTypes.DROPDOWN,
        validation: [validatorTypes.string, validatorTypes.optional],
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "display_image",
      type: types.JSON,
      isArray: false,
      allowNull: true,
      validation: [validatorTypes.json, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DOCUMENT_ALT, //UI Types
        validation: [validatorTypes.required],
        list: false,
        read: true,
        create: true,
        edit: true,
      },
    },

    {
      name: "floor_plan_title",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },
    {
      name: "floor_plan_subtitle",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.optional],
      ui: {
        ...textValuesUI,
      },
    },
    {
      name: "floors",
      type: types.JSON,
      isArray: true,
      allowNull: true,
      validation: [validatorTypes.array, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DYNAMICJSON, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
        dynamicArrayfeilds: [
          {
            name: "name",
            type: "text", //image , text, textarea, key_value
          },
          {
            name: "priority",
            type: "text", //image , text, textarea, key_value
          },

          {
            name: "floor_image",
            type: "image", //image , text, textarea, key_value
          },
          {
            name: "floor_icon",
            type: "image", //image , text, textarea, key_value
          },
          {
            name: "description",
            type: "textarea", //image , text, textarea, key_value
          },
          {
            name: "specification",
            type: "key_value", //image , text, textarea, key_value
          },
        ], // incas
      },
    },
    {
      name: "documents",
      type: types.JSON,
      isArray: true,
      allowNull: true,
      validation: [validatorTypes.array, validatorTypes.optional],
      ui: {
        // added for ui
        type: uiTypes.DYNAMICJSON, //UI Types
        validation: [], //UI Validation
        list: false,
        read: true,
        create: true,
        edit: true,
        dynamicArrayfeilds: [
          {
            name: "name",
            type: "text", //image , text, textarea, key_value
          },
          {
            name: "title",
            type: "text", //image , text, textarea, key_value
          },
          {
            name: "priority",
            type: "text", //image , text, textarea, key_value
          },
          {
            name: "document",
            type: "file", //image , text, textarea, key_value, file
          },
        ], // incas
      },
    },

    {
      name: "createdAt",
      type: types.DATE,
      allowNull: false,
      defaultValue: null,
      ui: {
        // added for ui
        type: uiTypes.DATE, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "updatedAt",
      type: types.DATE,
      allowNull: false,
      defaultValue: null,
      ui: {
        // added for ui
        type: uiTypes.DATE, //UI Types
        validation: [], //UI Validation
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "deletedAt",
      type: types.DATE,
      allowNull: true,
      defaultValue: null,
      read: false,
      ui: {
        // added for ui
        type: uiTypes.TEXT, //UI Types
        validation: [], //UI Validation
        list: false,
        read: false,
        create: false,
        edit: false,
      },
    },
  ],
};
module.exports = obj;
